import { usePersonnel } from 'features/Responder/features/Personnel/contexts/PersonnelContext';
import React from 'react';
import PersonelLayer from './PersonelLayer';

/**
 * Keep live personnel context updates scoped to the personnel map layer.
 */
const PersonnelLayerWithLiveData = () => {
  const { personnel } = usePersonnel();

  return <PersonelLayer personnel={personnel} />;
};

export default PersonnelLayerWithLiveData;
